export default __webpack_public_path__ + "static/media/kitchen5-afterB-1440w.f0572514.png";